/* eslint-disable import */
const isHidden = el => (
  el.offsetParent === null
);

const getValueById = (id) => {
  const el = document.getElementById(id);
  if (el !== null) {
    return el.value;
  }
  return '';
};

export {
  getValueById,
  isHidden,
};
/* eslint-enable import */
